export const FAMILY_RECIPES_ARTICLE = {
  path: "/blog/khmer-family-recipes-melbourne",
  title: "Khmer Family Recipes in Melbourne: Grandmother's Chicken, Kor Koh & Kroeung | ANGKOR",
  headline: "Khmer Family Recipes in Melbourne: The Dishes Behind the ANGKOR Table",
  description: "The Cambodian family recipes behind ANGKOR in West Melbourne: My Grandmother's Dish, slow-cooked Kor Koh beef stew, fresh kroeung curries and Fish Amok. 389 Spencer St.",
  image: "/manus-storage/cambodian-curry-premium_23eefa20.webp",
  imageSrcSet: "/manus-storage/cambodian-curry-premium-480_13688488.webp 480w, /manus-storage/cambodian-curry-premium-800_a6588971.webp 800w, /manus-storage/cambodian-curry-premium_23eefa20.webp 1600w",
  imageAlt: "Cambodian red curry made with fresh kroeung at ANGKOR West Melbourne",
  datePublished: "2026-10-23",
  dateLabel: "23 October 2026",
  byline: "By the ANGKOR team",
  excerpt: "The Cambodian family recipes behind ANGKOR in West Melbourne: My Grandmother's Dish, slow-cooked Kor Koh beef stew, fresh kroeung curries and Fish Amok.",
} as const;
